import { Directive, ElementRef, HostListener, Input, Output, EventEmitter  } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[ngModel][dropdownSelect]',
  providers: [NgModel]
})
export class DropdownSelectDirective {

  // Keystroke String buffer
  private keysEntered: string;
  constructor(private el: ElementRef, private ngModel: NgModel) { 
    this.keysEntered = '';
  }

  
  // Filters selection against the keystroke string buffer
  private testSelection = function(selection){
    return (selection.label.substring(0, this.keysEntered.length).toLowerCase() == this.keysEntered);
  }

  @Input() ArraySelection: any[];

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent> event;
    let that = this;

    if (e.keyCode == 8){
      if (that.keysEntered.length > 0){
        that.keysEntered = that.keysEntered.substr(0,that.keysEntered.length - 1);
      }
    }
    else {
      if ((e.keyCode > 47 && e.keyCode < 58) || (e.keyCode > 64 && e.keyCode < 91) || (e.keyCode > 96 && e.keyCode < 123)){
        that.keysEntered += e.key.toLowerCase();
      }
    }
    if (that.keysEntered == '') return false;

    if (that.ArraySelection) {
      var filteredSelections = that.ArraySelection.filter(that.testSelection, that);

      // if there is only one match, select it
      if (filteredSelections.length == 1) {
        that.ngModel.update.emit(filteredSelections[0].value);
        return;
      }
      
      // if there are multiple matches, choose the first one not currently selected
      for (var i=0; i<filteredSelections.length; i++) {
        if (that.ngModel.value !== filteredSelections[i].value) {
          that.ngModel.update.emit(filteredSelections[i].value);
          break;
        }
      }
    }
  }
}
